import { queryOptions, useQuery } from '@tanstack/react-query';

import type { SocialProvider } from '@nucleus-commerce/api-client/admin';

import { socialApi } from '../api/social-api';

import { socialKeys } from './social-keys';

/** Read live from the network on every open; the processing run changes once a day at most. */
export function socialCatalogQueryOptions(storeId: string, provider: SocialProvider) {
  return queryOptions({
    queryKey: socialKeys.catalog(storeId, provider),
    queryFn: () => socialApi.catalog(storeId, provider),
    staleTime: 60_000,
  });
}

/** `enabled` is false until the network is connected: the read needs a live token. */
export function useSocialCatalog(storeId: string, provider: SocialProvider, enabled: boolean) {
  return useQuery({ ...socialCatalogQueryOptions(storeId, provider), enabled });
}
